import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import messages from './messages';

export default {
  id: 'shipmentNumber',
  displayName: <FormattedMessage {...messages.shipmentNumber} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'fulfillmentPlanId',
  expectsArgumentAsArray: true,
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
